import React, { useState, useEffect } from 'react';
import { CategoryFormData, Category } from '../types/category';

interface CategoryFormProps {
  onSubmit: (data: CategoryFormData) => void;
  onCancel: () => void;
  loading: boolean;
  initialData?: Category | null;
}

const CategoryForm: React.FC<CategoryFormProps> = ({
  onSubmit,
  onCancel,
  loading,
  initialData,
}) => {
  const [formData, setFormData] = useState<CategoryFormData>({
    category: '',
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        category: initialData.category || '',
      });
    }
  }, [initialData]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-2xl font-semibold mb-6">
        {initialData ? 'Edit Category' : 'Create Category'}
      </h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Category Name *
          </label>
          <input
            type="text"
            name="category"
            value={formData.category}
            onChange={handleChange}
            required
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-berrys-orange focus:border-transparent"
            placeholder="Enter category name"
          />
        </div>

        <div className="flex space-x-4 pt-4">
          
          <button
            type="button"
            onClick={onCancel}
            className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 px-6 py-2 rounded-lg font-medium transition-colors"
          >
            Cancel
          </button>

          <button
            type="submit"
            disabled={loading}
            className="flex-1 bg-berrys-orange hover:bg-berrys-orange-dark text-white px-6 py-2 rounded-lg font-medium transition-colors disabled:opacity-50"
          >
            {loading
              ? initialData
                ? 'Updating...'
                : 'Creating...'
              : initialData
              ? 'Update Category'
              : 'Create Category'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CategoryForm;

